/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const listReferralsV1QuerySchema = z.object({
  status: z.string().optional(),
  abuseFlag: z.string().optional(),
  limit: z.number().int().min(1).max(200).default(50),
  offset: z.number().int().min(0).default(0),
});

export type IListReferralsV1Query = z.input<typeof listReferralsV1QuerySchema>;
